import { render } from "./commonPart.vue?vue&type=template&id=99c3d080&scoped=true"
import script from "./commonPart.vue?vue&type=script&lang=js"
export * from "./commonPart.vue?vue&type=script&lang=js"

import "./commonPart.vue?vue&type=style&index=0&id=99c3d080&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c3d080"]])

export default __exports__